import { render, staticRenderFns } from "./PatientMedecin.vue?vue&type=template&id=457664aa&scoped=true"
import script from "./PatientMedecin.vue?vue&type=script&lang=js"
export * from "./PatientMedecin.vue?vue&type=script&lang=js"
import style0 from "./PatientMedecin.vue?vue&type=style&index=0&id=457664aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457664aa",
  null
  
)

export default component.exports